import React, {Component} from "react";
import {connect} from "react-redux";

import {loadDataAction, setMapDataAction, startOverMapAction} from "./../../actions/DataAction";

import SubNavTabs from "./../../components/nav/SubNavTabs";
import Introduction from "./../../components/blocks/Introduction";

import {VIEWS, FILE_KEYS, OCCUPATIONAL_FIELDS} from "./../../helpers/consts";

import OccEmploymentShare from "../../components/slides/occupational/OccEmploymentShare";

import "./Occupational.css";

class Occupational extends Component {

  constructor(props) {
    super();
    this.getFieldKey = this.getFieldKey.bind(this);
    this.getSelectedField = this.getSelectedField.bind(this);
    this.launchDataAction = this.launchDataAction.bind(this);
  }

  getFieldKey(){
    const {options} = this.props;
    return OCCUPATIONAL_FIELDS[options.measure_occ.key === "delta" ? `delta` : `${options.perspective_occ.key}_${options.share_occ.key}`];
  }

  getSelectedField(){
    const {selectedOccupation} = this.props;
    return `${selectedOccupation.id}_${this.getFieldKey()}`;
  }

  getSelectedFilter(){
    const field = this.getSelectedField();
    return ['has', field];
  }

  componentDidMount() {
    this.props.loadDataAction([
      FILE_KEYS.OCCUPATIONAL_DATA,
      FILE_KEYS.OCCUPATIONAL_TOP10_SHARE
    ], this.props.db);
    this.props.startOverMap();
    this.launchDataAction();
  }

  componentDidUpdate(prevProps, prevState) {
    const {selectedOccupation} = this.props;
    if (
      prevProps.geojson !== this.props.geojson ||
      prevProps.selectedOccupation.id !== selectedOccupation.id ||
      prevProps.options.perspective_occ !== this.props.options.perspective_occ ||
      prevProps.options.measure_occ !== this.props.options.measure_occ ||
      prevProps.options.share_occ !== this.props.options.share_occ
      ) {
      this.launchDataAction();
    }
  }

  launchDataAction() {
    const {options, setMapDataAction, selectedOccupation} = this.props;
    if (options.perspective_occ && options.share_occ && options.measure_occ){
      const fieldSelected = this.getFieldKey();
      if (fieldSelected) {
        setMapDataAction(VIEWS.OCCUPATIONAL, this.getSelectedFilter(), this.getSelectedField(), selectedOccupation);
      }
    }
  }

  render() {
    return (
      <div id="fow-view-regional-cluster">
        <SubNavTabs baseUrl={`/map/${VIEWS.OCCUPATIONAL}`}>
          <div>
            <Introduction title="A shifting mix">
              <div className="fow-col fow-col-1 fow-col-count-2 fow-md-col-count-1">
                <p>The Internet disrupted many industries and eliminated many jobs. But it also gave rise to new roles such as web developers, app developers, social media marketers, search engine optimization consultants, and user experience designers.</p>
                <p>Our research suggests that the mix of jobs will not look the same in 2030 as it does today. Even as employment declines for administrative assistants and manufacturing production workers, for instance, we anticipate strong growth for software developer and nurses.</p>
                <p>Furthermore, occupational shifts will not play out exactly the same way across different local economies. Here we map these trends at the local level, showing where specific occupations are concentrated today and where they are likely to grow or decline in the future.</p>
              </div>
            </Introduction>
          </div>
          <div>
            <OccEmploymentShare year={2018} title="Where were these occupations concentrated in 2018?" />
          </div>
          <div>
            <OccEmploymentShare year={2030} title="Where are these occupations expected to grow by 2030?" subtitle="Occupational employment growth 2018-30" />
          </div>
        </SubNavTabs>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    geojson: state.db.map.geojsonOptions[VIEWS.OCCUPATIONAL],
    db: state.db,
    selectedOccupation: state.settings.map["Occupations"],
    options: state.settings.switch
  };
};
const mapDispatchToProps = dispatch => ({
  startOverMap: () => dispatch(startOverMapAction()),
  loadDataAction: (keys, db) => dispatch(loadDataAction(keys, db)),
  setMapDataAction: (view, filter, field, entity) => dispatch(setMapDataAction(view, filter, field, entity))
});

export default connect(mapStateToProps, mapDispatchToProps)(Occupational);
